import { awaitRequests, promise } from '../../../helpers';
import { firebaseUpdate } from '../firebase';

const updateRegionalEntityRelations = (item, docId) => {
    // eslint-disable-next-line
    return (dispatch, getState, getFirebase) => {
        if (item && docId) {
            const reqs = [];

            reqs.push(
                dispatch(
                    firebaseUpdate({
                        collection: 'learningCommunities',
                        where: [['regionalEntityId', '==', docId]],
                        data: { regionalEntityName: item.name || '' },
                    }),
                ),
            );

            reqs.push(
                dispatch(
                    firebaseUpdate({
                        collection: 'facilitators',
                        where: [['regionalEntityId', '==', docId]],
                        data: { regionalEntityName: item.name || '' },
                    }),
                ),
            );

            reqs.push(
                dispatch(
                    firebaseUpdate({
                        collection: 'learningCommunityGroups',
                        where: [['regionalEntityId', '==', docId]],
                        data: { regionalEntityName: item.name || '' },
                    }),
                ),
            );

            reqs.push(
                dispatch(
                    firebaseUpdate({
                        collection: 'groupsParticipants',
                        where: [['regionalEntityId', '==', docId]],
                        data: { regionalEntityName: item.name || '' },
                    }),
                ),
            );

            reqs.push(
                dispatch(
                    firebaseUpdate({
                        collection: 'facilitatorsGroups',
                        where: [['regionalEntityId', '==', docId]],
                        data: { regionalEntityName: item.name || '' },
                    }),
                ),
            );

            return awaitRequests(reqs);
        }

        return promise();
    };
};

export default updateRegionalEntityRelations;
